import { Link } from "react-router-dom";
import "./Header.scss";
import React from "react";
import { FaFacebook, FaLinkedin, FaInstagram, FaYoutube } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import Logo from "../../../common/BrandLogo";
import { brand } from "../../../../config/brands";

const Footer = React.forwardRef((props, ref) => {
  const handleOrthoCheckClick = () => {
    localStorage.removeItem("provider_api_key");
    localStorage.removeItem("schedulers_customer_config");
    localStorage.removeItem("orthocheck_ai_initiate");
    localStorage.removeItem("orthocheck_initiate");
    localStorage.removeItem("orthocheck_results");
    localStorage.removeItem("provider_enhanced");
    localStorage.removeItem("provider_info");
  };
  return (
    <footer className="bg-white pt-2 " ref={ref}>
      <div className="container ">
        <div className="row gy-4 justify-space-between">
          {/* Subscribe (leftmost) */}
          <div className="mt-5">
            <Link to="/" onClick={handleOrthoCheckClick}>
              <Logo viewBox="0 0 143 48" width="11rem" />
              {/* <img src={MOPLOGO} alt="MOP Logo" style={{ cursor: "pointer", height: "50px" }} /> */}
            </Link>
          </div>
          <div className="col-12 col-md-10">
            <p
              className="text-muted mb-4"
              style={{
                fontSize: "18px",
                fontWeight: "400",
                fontFamily: "Nunito Sans, Arial, sans-serif",
              }}
            >
              {brand.tagline.split("\n")[0]} <br />
              {brand.tagline.split("\n")[1]}
            </p>
            <div className="d-flex gap-3 mb-2">
              <span
                className="border"
                style={{
                  background: "#f8fafc",
                  borderRadius: "6px",
                  width: "35px",
                  height: "35px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <FaFacebook
                  className="footer-link text-secondary fs-5 cursor-pointer"
                  onClick={() => window.open(brand.social.facebook)}
                />
              </span>
              <span
                className="border"
                style={{
                  background: "#f8fafc",
                  borderRadius: "6px",
                  width: "35px",
                  height: "35px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <FaInstagram
                  className="footer-link text-secondary fs-5 cursor-pointer"
                  onClick={() => window.open(brand.social.instagram)}
                />
              </span>
              <span
                className="border"
                style={{
                  background: "#f8fafc",
                  borderRadius: "6px",
                  width: "35px",
                  height: "35px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <FaXTwitter
                  className="footer-link text-secondary fs-5 cursor-pointer"
                  onClick={() => window.open(brand.social.twitter)}
                />
              </span>
              <span
                className="border"
                style={{
                  background: "#f8fafc",
                  borderRadius: "6px",
                  width: "35px",
                  height: "35px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <FaLinkedin
                  className="footer-link text-secondary fs-5 cursor-pointer"
                  onClick={() => window.open(brand.social.linkedin)}
                />
              </span>
              <span
                className="border"
                style={{
                  background: "#f8fafc",
                  borderRadius: "6px",
                  width: "35px",
                  height: "35px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <FaYoutube
                  className="footer-link text-secondary fs-5 cursor-pointer"
                  onClick={() => window.open(brand.social.youtube)}
                />
              </span>
            </div>
          </div>

          <div className="col-12 col-md-10">
            <div
              className="d-flex gap-3 mb-2 mobile-column"
              style={{
                fontFamily: "Nunito Sans, Arial, sans-serif",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <p className="text-muted">
                <a
                  href={brand.checkerPath}
                  className="text-muted text-decoration-none"
                >
                  {brand.checkerName}
                </a>
              </p>
              <p className="text-muted" style={{ marginRight: "10px" }}>
                <a
                  href={`/providers`}
                  className="text-muted text-decoration-none"
                >
                  Find a Provider
                </a>
              </p>
              <p className="text-muted" style={{ marginRight: "10px" }}>
                <a
                  href={`${brand.webUrl}${brand.educationPath}`}
                  className="text-muted text-decoration-none"
                >
                  Education Library
                </a>
              </p>
              {brand.key !== "mdp" && (
                <p className="text-muted" style={{ marginRight: "10px" }}>
                  <a
                    href={`${brand.webUrl}/for-providers`}
                    className="text-muted text-decoration-none"
                  >
                    For Providers
                  </a>
                </p>
              )}
              <p className="text-muted" style={{ marginRight: "10px" }}>
                <a
                  href={`${brand.webUrl}/blog`}
                  className="text-muted text-decoration-none"
                >
                  Blog
                </a>
              </p>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="d-flex flex-column flex-md-row justify-content-between col-12 border-top mt-1 mb-5 pt-4">
          <div className="d-flex gap-3 fs-6 text-muted order-1 order-md-2 justify-content-center justify-content-md-end mb-2 mb-md-0">
            <a
              href={`${brand.webUrl}/privacy-policy`}
              target="_blank"
              rel="noopener noreferrer"
              className="cursor-pointer text-muted text-decoration-none"
            >
              Privacy Policy
            </a>
            <a
              href={`${brand.webUrl}/terms-of-service`}
              target="_blank"
              rel="noopener noreferrer"
              className="cursor-pointer text-muted text-decoration-none"
            >
              Terms of Service
            </a>
          </div>
          <div className="fs-6 text-muted order-2 order-md-1 text-center text-md-start">
            <p>© 2025 Clinekt Health, LLC</p>
          </div>
        </div>
      </div>
    </footer>
  );
});

export default Footer;
